import { cx } from './cx';
import type { Tone } from './Badge';

export interface ProgressProps {
  /** 0 to 1. Anything outside is clamped rather than overflowing the track. */
  value: number;
  label?: string;
  /** Show the percentage next to the bar. */
  showValue?: boolean;
  tone?: Extract<Tone, 'brand' | 'success' | 'warn' | 'danger' | 'neutral'>;
  size?: 'sm' | 'md';
  className?: string;
}

const fills: Record<string, string> = {
  neutral: 'bg-ink-3',
  brand: 'bg-forest',
  success: 'bg-success',
  warn: 'bg-warn',
  danger: 'bg-danger',
};

/** A 4px bar on a ground track, green fill, square ends. */
export function Progress({ value, label, showValue, tone = 'brand', size = 'md', className }: ProgressProps) {
  const pct = Math.round(Math.min(1, Math.max(0, Number.isFinite(value) ? value : 0)) * 100);
  return (
    <div className={cx('flex flex-col gap-1', className)}>
      {label || showValue ? (
        <div className="flex items-baseline justify-between gap-2 text-xs text-ink-3">
          {label ? <span>{label}</span> : <span />}
          {showValue ? <span className="record text-ink-2">{pct}%</span> : null}
        </div>
      ) : null}
      <div
        role="progressbar"
        aria-valuenow={pct}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={label}
        className={cx('w-full overflow-hidden bg-paper-deep', size === 'sm' ? 'h-[3px]' : 'h-1')}
      >
        <div className={cx('h-full transition-[width] duration-reveal ease-ct', fills[tone])} style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
